import { Box, Typography } from "@mui/material";

const CustomOverviewRectangle = ({ background, image, text, number, onClick, subtitle, iconElement }) => {
  return (
    <Box
      onClick={onClick}
      sx={{
        borderRadius: "8px",
        background: `url(${background}) center/cover`,
        padding: "2em",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "200px",
        position: "relative",
        color: "#fff",
        textShadow: "0 2px 4px rgba(0,0,0,0.2)",
        cursor: onClick ? "pointer" : "default",
        transition: "transform 0.15s ease, box-shadow 0.15s ease",
        "&:hover": onClick ? { transform: "translateY(-2px)", boxShadow: "0 8px 24px rgba(0,0,0,0.18)" } : {},
      }}>

      <Box sx={{ mb: 1, width: "3em", display: "flex", justifyContent: "center", alignItems: "center" }}>
        {iconElement
          ? iconElement
          : <img src={image} alt="" style={{ width: "100%", filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.1))" }} />}
      </Box>
      <Typography variant="body1" sx={{ fontWeight: 600, textAlign: "center", mb: 0.5 }}>
        {text}
      </Typography>
      {number && (
        <Typography variant="h5" sx={{ fontWeight: 700 }}>
          {number}
        </Typography>
      )}
      {subtitle && (
        <Typography variant="caption" sx={{ mt: 0.5, opacity: 0.85, textAlign: "center" }}>
          {subtitle}
        </Typography>
      )}
    </Box>
  );
};

export default CustomOverviewRectangle;
